// react
import { useReducer, useEffect } from "react";

export const useAutoReload = (minutesBeforeReload) => {
  const [reloadDependency, forceReload] = useReducer((number) => number + 1, 0);

  // auto reload after given minutes
  useEffect(() => {
    const intervalId = setInterval(
      () => forceReload(),
      minutesBeforeReload * 60 * 1000
    );

    return () => {
      clearInterval(intervalId);
    };
  }, [minutesBeforeReload]);

  return reloadDependency;
};
